module.exports = __webpack_public_path__ + "img/imag-autora.402702a5.png";